

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class LocalizedEntity_ManagedObject

class LocalizedEntity_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: language
    set language(value:string) {
        this.setValueForKey(value, 'language');
    }
    get language():string {
        return this.valueForKey('language');
    }
    set languagePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'language');
    }
    get languagePrimitiveValue():string {
        return this.primitiveValueForKey('language');
    }
}
